module.exports = __webpack_public_path__ + "img/16_36.91a15405.png";